export const defaultAppTitle = "Porsche Finder Dealer App"
